import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangelogsComponent} from './changelogs.component';
import {SharedModule} from '../shared/shared.module';
import {CoreModule} from '../core/core.module';
import {ButtonModule} from 'primeng/button';
import {PanelModule} from "primeng/panel";
import {MarkdownModule} from "ngx-markdown";
import {ChangelogsRoutingModule} from "./changelogs-routing.module";


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    ButtonModule,
    PanelModule,
    MarkdownModule,
    ChangelogsRoutingModule
  ],
  declarations: [ChangelogsComponent],
  exports: [ChangelogsComponent]
})
export class ChangelogsModule { }
